<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RBYcnA/tc-custom/9781429932165.jpg?1733103890148" alt="This image is the cover for the book Never Throw Rice at a Pisces"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Never Throw Rice at a Pisces
      </h1>
      <p class="bookDescription body article font2">
        <p>Simply because no two brides (or astrological signs) are ever the same. . . .<br/><br/>Congratulations, bride-to-be! You're newly engaged, you've flashed your ring to all your neighbors, and you've called all your friends and family with the exciting news—so what do you do next? Read your horoscope, of course! <br/><br/>You've been following the stars ever since you can remember, and now you can use astrology as a tool to plan the biggest day of your life! <i>Never Throw Rice at a Pisces </i>helps you use the powers of your astrological sign to make your wedding relaxed, romantic, and magically memorable. Astrologer Stacey Wolf gives smart, easy-to-use sign-specific advice on topics such as:<br/><br/>•           Vows to inspire a Scorpio bride and Cancer groom<br/><br/>•           How to talk a headstrong Aries groom into just about anything<br/><br/>•           The perfect cake for a whimsical Gemini bride<br/><br/>•           A heavenly honeymoon for an Aquarius/Libra couple<br/><br/>•           What a Sagittarius bride should avoid for a stress-free wedding<br/><br/>Peppered with fun sidebars, stories from other astrobrides, and quick tips based on the twelve zodiac signs to solve last-minute dilemmas, <i>Never Throw Rice at a Pisces </i>will help you plan the perfect wedding and honeymoon you were born to have!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stacey Wolf
      </h2>
      
      <p class="authorDescription body article"><P>Pisces STACEY WOLF, a professional psychic astrologer for nearly 20 years, is the astrologer for <I>Cosmopolitan</I> and the author of <I>Secrets of the Signs</I>, <I>Love Secrets of the Signs</I> and <I>Get Psychic</I>. Stacey has appeared on numerous TV and radio shows including <I>The View</I>, <I>Beyond with James Van Praagh</I>, <I>Late Night with David Letterman</I> and ABC's <I>World News Now</I>. Stacey has been featured in<I> Bridal Guide,</I><I>Mademoiselle, J14, Twist, American Woman, Woman's Own</I>, and <I>Fate</I> magazines; as well as the books <I>The 100 Top Psychics in America</I> and <I>Esoteric Guide to New York</I>. When she's not swapping her apartment and traveling the globe, she lives in Manhattan where she pet-sits for her friend's animal children.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?54586220